import { useAppStore } from '@/stores/app.store'
import { computed, ref, type ComputedRef } from 'vue'

export enum MoScreen {
  SCAN_OP = 'scan-op',
  EXCEPTION = 'exception',
  MO_INFO = 'mo-info',
  PRODUCT_DETAILS = 'product-details'
}

export function useInternalRouter() {
  const appStore = useAppStore()

  const isScanningTag = ref(false)

  const manufacturingOrder = computed(() => appStore.currentManufacturingOrder)

  const isManufacturingOrderCompleted = computed(
    () => manufacturingOrder.value?.status === 'COMPLETED'
  )

  const showCam = ref(false)

  const preventGoBack = computed(() => showCam.value || isScanningTag.value)

  async function goBack() {
    if (appStore.nonConformityView) {
      appStore.actions.setNonConformityView(false)
      return
    }

    if (showCam.value) {
      showCam.value = false
      return
    }

    if (isScanningTag.value) {
      isScanningTag.value = false
    }
  }

  const currentScreen: ComputedRef<MoScreen> = computed(() => {
    if (!manufacturingOrder.value) {
      return MoScreen.SCAN_OP
    } else if (isManufacturingOrderCompleted.value) {
      return MoScreen.EXCEPTION
    } else if (!isScanningTag.value) {
      return MoScreen.MO_INFO
    } else {
      return MoScreen.PRODUCT_DETAILS
    }
  })

  return {
    manufacturingOrder,
    isScanningTag,
    preventGoBack,
    currentScreen,
    goBack
  }
}
